import commonPropTypes from '../../../constants/commonPropTypes'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import PendingTooltip from './pendingTooltip'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class FieldLabel extends Component {
  static propTypes = {
    ...commonPropTypes,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    required: PropTypes.bool,
    pendingApproval: PropTypes.bool,
  }

  static defaultProps = {
    error: false,
    required: false,
  }

  render() {
    const {
      className,
      elmId,
      inputName,
      label,
      error,
      required,
      pendingApproval,
    } = this.props

    return (
      <span>
        {pendingApproval && <PendingTooltip />}
        <label
          data-elm-id={`${elmId}_label`}
          htmlFor={inputName}
          className={cx('label', className)}
        >
          <span className={cx(error ? 'warning' : '')}>{label}</span>
          <span className={cx('warning')}>{required ? ' *' : ''}</span>
        </label>
      </span>
    )
  }
}

export default FieldLabel
